<template>
  <div class="slc_w mb-x custom-radio">
    <label
        v-for="option in calculatedOptions"
        :key="option.value"
        class="slc"
        :class="{ slc_ac: modelValue === option.value }"
        @mouseover="hoveredItem = option.value" @mouseleave="hoveredItem = null"
    >
      <input
          type="radio"
          :value="option.value"
          name="regional_coverage"
          :checked="modelValue === option.value"
          @change="$emit('update:modelValue', option.value)"
          class="hidden"
      />
      <img :src="option.icon" loading="lazy" alt="" class="slc_i" />
      <span>{{ option.label }}</span>
    </label>
  </div>
    <div class="space-holder">
      <div class="slc_w mb-x" v-if="displayedItem === 'EUROPE'" >
        <div class="slc_info">
          <div class="icoc">
            <div></div>
          </div>
          <div class="co">
            <div class="px mb">Európa</div>
            <div class="ps">
              <p>Poistenie platí na území geografickej oblasti Európy – okrem Turecka.<br />
              Poistenie platí aj na území Kanárskych ostrovov, Alžírska, Maroka, Tuniska a Ruskej federácie.
              </p>
              <p>
              Poistenie neplatí na území Slovenska, na území krajiny Vášho trvalého pobytu a krajiny, v ktorej si hradíte povinné zdravotné poistenie.
              </p>
              <p>
              Pre územie Turecka je potrebné dojednať územný rozsah SVET, aj pokiaľ cestujete do európskej časti krajiny.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="slc_w mb-x" v-else-if="displayedItem === 'WORLD'">
        <div class="slc_info">
          <div class="icoc">
            <div></div>
          </div>
          <div class="co">
            <div class="px mb">Svet</div>
            <div class="ps">
              Poistenie platí pre celý svet s výnimkou Slovenska, krajiny Vášho trvalého pobytu a krajiny, v ktorej si hradíte povinné zdravotné poistenie.
             </div>
          </div>
        </div>
      </div>
      <div class="slc_w mb-x" v-else-if="displayedItem === 'SLOVAKIA'">
        <div class="slc_info">
          <div class="icoc">
            <div></div>
          </div>
          <div class="co">
            <div class="px mb">Slovensko</div>
            <div class="ps">
              Poistenie platí na území Slovenska.
            </div>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
import Options from "@/config/options";
export default {
  name: 'RegionalCoverageRadio',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    travelReason: Array,
  },
  data() {
    return {
      hoveredItem: null,
      areaOptions: Options.regional_coverage,
    }
  },
  methods: {
    arrayIncludesArray(arr, target) {
      return !(target.map(item => {
        return arr.includes(item);
      }).filter(item => !item).length);
    },
  },
  computed: {
    displayedItem(){
      if (this.hoveredItem){
        return this.hoveredItem;
      }else{
        return this.modelValue;
      }
    },
    calculatedOptions(){
      return this.areaOptions.filter((option) => {
        console.log(option.travelReasons, this.travelReason);
        if (option.travelReasons) {
          console.log(this.arrayIncludesArray(option.travelReasons, this.travelReason));
        }
        return !option.travelReasons || this.arrayIncludesArray(option.travelReasons, this.travelReason);
      })
    }
  }
}
</script>

<style scoped></style>
